import React from 'react';
import styles from './MedicationsDashboard.module.scss';

export function MedicationsDashboard() {
    return (
        <div className={styles.container}>
            <h1>Medications dash board</h1>
        </div>
    );
}
